import {StyleSheet} from 'react-native';

import {MAX_CONTENT_WIDTH} from '/constant/data.constant';
import {indent} from '/constant/layout.constant';
import {codGray} from '/theme/color/secondary.color';

export const styles = StyleSheet.create({
  base: {
    flex: 1,
    flexWrap: 'nowrap' as const,
    overflow: 'visible' as const,
    width: '100%' as const,
    maxWidth: MAX_CONTENT_WIDTH as number,
    alignSelf: 'center' as const,
  },
  container: {
    overflow: 'visible' as const,
    paddingHorizontal: indent,
    minHeight: 44,
    //alignItems: 'center' as const, // Commented out elements due to unexpected centering on the All Candidates screen
    width: '100%' as const,
  },
  icons: {
    marginVertical: indent * 0.8,
    alignItems: 'center' as const,
  },
  icon: {
    fontSize: 38,
    color: codGray,
  },
  button: {alignSelf: 'flex-start'},
});
